import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import '@/index.css';
import '@/dealer-approved-palette.css';
import '@/dealer-corporate-casework.css';
import '@/dealer-prestige-master.css';
import '@/dealer-prestige-legacy-guard.css';
import '@/dealer-prestige-components.css';
import '@/dealer-prestige-equipment.css';
import '@/dealer-reference-match.css';
import '@/dealer-reference-structure.css';
import '@/dealer-stage-rail.css';
import '@/dealer-reference-final.css';
import '@/dealer-reference-header.css';
import '@/dealer-horizontal-nav.css';
import '@/dealer-horizontal-nav-flyout.css';
import '@/sentinel-executive.css';
import '@/sentinel-executive-pages.css';
import '@/sentinel-executive-forms.css';

const AppRuntime = lazy(() => import('@/AppRuntime'));

function BootstrapFallback() {
  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center" data-testid="application-bootstrap-fallback">
      <div className="flex flex-col items-center gap-3 text-slate-400">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-amber-400 border-t-transparent" />
        <span className="text-[10px] font-bold uppercase tracking-[0.18em]">XM Sentinel</span>
      </div>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Suspense fallback={<BootstrapFallback />}>
      <AppRuntime />
    </Suspense>
  </React.StrictMode>,
);